import classNames from "classnames";

import { Measurement, Size } from "@/api/generatedTypes";
import { CardHeader } from "@/components/CardHeader";
import { MeasurementsTable } from "@/components/MeasurementsTable";
import { useLockBodyScrollModified } from "@/hooks/useLockBodyScrollModified";
import { useModalAppearing } from "@/hooks/useModalAppearing";

import { ModalPortal } from "../ModalPortal";
import styles from "./MeasurementsModal.module.scss";

interface MeasurementsModalProps {
  measurements?: Measurement[];
  sizes?: Size[];
  close(): void;
  className?: string;
  isOpen: boolean;
}

const MeasurementsModal = ({
  measurements = [],
  sizes = [],
  close,
  className,
  isOpen,
}: MeasurementsModalProps) => {
  const { isVisible, mounting, hiding } = useModalAppearing({ isOpen });
  useLockBodyScrollModified(isOpen);

  if (!isVisible) return null;

  return (
    <ModalPortal>
      <div
        className={classNames(
          styles.root,
          {
            [styles.show]: mounting,
            [styles.hide]: hiding,
          },
          className
        )}
        onClick={close}
      >
        <CardHeader
          className={styles.header}
          leftSlot={
            <button
              className={classNames(styles.hideButton, {
                [styles.hideButton_openedModal]: isVisible,
              })}
              onClick={close}
            >
              cкрыть
            </button>
          }
        />
        <div className={styles.content}>
          <MeasurementsTable measurements={measurements} sizes={sizes} />
        </div>
      </div>
    </ModalPortal>
  );
};

export default MeasurementsModal;
